<!--
 * @Descripttion: 登录页面组件(密码/短信验证码双模式)
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
-->
<template>
  <div class="login">
    <div>
      <el-card class="box-card" shadow="hover">
        <router-link class="login-logo-link" to="/">
          <img class="login-logo" src="../assets/imgs/clogo.png" alt />
        </router-link>
        <div class="clearfix">
          <span>Login</span>
        </div>
        <!-- 登录方式切换 -->
        <div class="login-tabs">
          <span
            class="login-tab"
            :class="{ active: activeTab === 'password' }"
            @click="activeTab = 'password'"
          >Password</span>
          <span
            class="login-tab"
            :class="{ active: activeTab === 'otp' }"
            @click="activeTab = 'otp'"
          >OTP</span>
        </div>
        <div class="item">
          <!-- 密码登录 -->
          <el-form
            v-if="activeTab === 'password'"
            :model="form"
            status-icon
            :rules="rules"
            ref="form"
          >
            <el-form-item prop="user_name">
              <el-input v-model="form.user_name" placeholder="Username"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="form.password" placeholder="Password"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="math-captcha">
                <span class="math-expression" @click="refreshCaptcha">{{ captcha.expression }}</span>
                <el-input v-model="captcha.value" placeholder="Answer"></el-input>
              </div>
            </el-form-item>
            <div style="margin-top:15px">
              <a href="javascript:;" class="btn-gradient desert block" @click="login('form')">Login</a>
            </div>
          </el-form>
          <!-- 短信验证码登录 -->
          <el-form
            v-if="activeTab === 'otp'"
            :model="otpForm"
            status-icon
            :rules="otpRules"
            ref="otpForm"
          >
            <el-form-item prop="phone">
              <el-input v-model="otpForm.phone" placeholder="Phone Number (10 digits)" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="otpForm.code" placeholder="6-digit verification code" maxlength="6">
                <el-button
                  slot="append"
                  @click="sendCode"
                  :disabled="cannotClick"
                >{{content}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="math-captcha">
                <span class="math-expression" @click="refreshCaptcha">{{ captcha.expression }}</span>
                <el-input v-model="captcha.value" placeholder="Answer"></el-input>
              </div>
            </el-form-item>
            <div style="margin-top:15px">
              <a href="javascript:;" class="btn-gradient desert block" @click="smsLogin('otpForm')">Login</a>
            </div>
          </el-form>
          <el-link
            type="primary"
            href="/#/register"
            style="float:right;margin-bottom:10px;"
          >Don't have an account? Please register first ></el-link>
        </div>
        <div class="line"></div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
export default {
  name: 'Login',
  data() {
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('enter one user name'))
      } else if (value.length < 5 || value.length > 15) {
        callback(new Error('The username length should be between 5 and 15'))
      }
      callback()
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('The password length should be between 8 and 16'))
      }
      callback()
    }
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your phone number'))
      } else if (!/^[0-9]{10}$/.test(value)) {
        callback(new Error('Please enter a 10-digit phone number'))
      }
      callback()
    }
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the verification code'))
      } else if (!/^[0-9]{6}$/.test(value)) {
        callback(new Error('Please enter a 6-digit verification code'))
      }
      callback()
    }
    return {
      activeTab: 'password',
      form: {
        user_name: '',
        password: ''
      },
      rules: {
        user_name: [{ validator: validateUser, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }]
      },
      otpForm: {
        phone: '',
        code: ''
      },
      otpRules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      captcha: {
        id: '',
        expression: '',
        value: ''
      },
      content: 'Send Code',
      cannotClick: false,
      totalTime: 60
    }
  },
  methods: {
    ...mapActions(['setUser']),
    // 登录成功统一处理:写入本地存储和vuex后跳转
    handleLoginSuccess(res) {
      localStorage.setItem('user', JSON.stringify(res.data.user))
      localStorage.setItem('token', res.data.token)
      this.setUser(res.data.user)
      this.notifySucceed('Login successful')
      this.$router.push({
        name: 'Home'
      })
    },
    // 密码登录
    login(formName) {
      var self = this
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        if (self.captcha.value === '') {
          self.notifyError('Please answer the math question', null)
          return
        }
        self.form.captcha_id = self.captcha.id
        self.form.captcha_value = self.captcha.value
        userAPI
          .postLogin(self.form)
          .then(res => {
            if (res.status === 200) {
              self.handleLoginSuccess(res)
            } else {
              self.refreshCaptcha()
              self.captcha.value = ''
              self.notifyError('Login failed', res.msg)
            }
          })
          .catch(error => {
            self.refreshCaptcha()
            self.captcha.value = ''
            self.notifyError('Login failed', error)
          })
      })
    },
    // 短信验证码登录
    smsLogin(formName) {
      var self = this
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        if (self.captcha.value === '') {
          self.notifyError('Please answer the math question', null)
          return
        }
        userAPI
          .smsLogin({
            phone: self.otpForm.phone,
            code: self.otpForm.code
          })
          .then(res => {
            if (res.status === 200) {
              self.handleLoginSuccess(res)
            } else {
              self.notifyError('Login failed', res.msg)
            }
          })
          .catch(error => {
            self.notifyError('Login failed', error)
          })
      })
    },
    // 倒计时
    countDown() {
      var self = this
      if (self.cannotClick) return
      self.cannotClick = true
      self.content = self.totalTime + 's'
      var clock = window.setInterval(function() {
        self.totalTime--
        self.content = self.totalTime + 's'
        if (self.totalTime < 0) {
          window.clearInterval(clock)
          self.content = 'Send Code'
          self.totalTime = 60
          self.cannotClick = false
        }
      }, 1000)
    },
    // 发送短信验证码(需算式验证码前置校验)
    sendCode() {
      var self = this
      if (self.cannotClick) {
        return
      }
      if (self.otpForm.phone === '') {
        self.notifyError('Please enter your phone number', null)
        return
      }
      if (self.captcha.value === '') {
        self.notifyError('Please answer the math question', null)
        return
      }
      var form = {
        phone: self.otpForm.phone,
        captcha_id: self.captcha.id,
        captcha_value: self.captcha.value
      }
      userAPI
        .sendSMSCode(form)
        .then(res => {
          if (res.status === 200) {
            self.countDown()
            self.captcha.value = ''
            self.refreshCaptcha()
            self.notifySucceed('Verification code sent')
          } else {
            self.refreshCaptcha()
            self.captcha.value = ''
            self.notifyError('Failed to send code', res.msg)
          }
        })
        .catch(error => {
          self.refreshCaptcha()
          self.captcha.value = ''
          self.notifyError('Failed to send code', error)
        })
    },
    // 刷新算式验证码
    refreshCaptcha() {
      var self = this
      userAPI.getMathCaptcha().then(res => {
        if (res.status === 200) {
          self.captcha.id = res.data.captcha_id
          self.captcha.expression = res.data.expression
        }
      })
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
  margin-bottom: 20px;
}

.login-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.login-tab {
  padding: 5px 25px;
  cursor: pointer;
  font-size: 15px;
  color: #757575;
  border-bottom: 2px solid transparent;
}

.login-tab.active {
  color: #8B5A2B;
  border-bottom: 2px solid #8B5A2B;
  font-weight: bold;
}

.math-captcha {
  display: flex;
  align-items: center;
  width: 100%;
}

.math-expression {
  min-width: 110px;
  height: 40px;
  line-height: 40px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 16px;
  font-weight: bold;
  color: #8B5A2B;
  cursor: pointer;
  user-select: none;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 300px;
  border-radius: 10px;
}
.login-logo-link {
  display: flex;
  justify-content: center;
}
.login-logo {
  width: 120px;
  height: auto;
}
.box-card .line {
  height: 30px;
  width: 300px;
  margin: 0 auto;
  border-bottom: 1px solid #c0c0c0;
}
</style>
